(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  var button = event.target.closest('[data-feature-scroll]');
  if (!button) return;
  var gallery = button.closest('[data-feature-gallery]');
  var strip = gallery && gallery.querySelector('.airjet-feature-strip');
  if (!strip) return;
  var card = strip.querySelector('.feat');
  var gap = parseFloat(getComputedStyle(strip).columnGap) || 0;
  var distance = card ? card.getBoundingClientRect().width + gap : strip.clientWidth;
  strip.scrollBy({
    left: Number(button.dataset.featureScroll) * distance,
    behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
  });
});

  } catch(e) { console.error(e); }
})();
})();
